import { render, staticRenderFns } from "./NewAnswer.vue?vue&type=template&id=bc9a0b4e&"
import script from "./NewAnswer.vue?vue&type=script&lang=js&"
export * from "./NewAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports